var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localSvg)?_c('span',{staticClass:"v2-icon-svg",style:(_vm.svgStyle),domProps:{"innerHTML":_vm._s(_vm.localSvg)}}):_c('span',{staticClass:"material-symbols-outlined",style:(_vm.iconStyle)},[_vm._v("\n  "+_vm._s(_vm.iconName)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }